<template>
  <v-dialog v-model="dialog" width="1000">
    <v-card flat>
      <v-img :src="imgUrl" height="100%" max-height="650px" @click="dialog = false"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["imgUrl", "dialog"]
}
</script>
